/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMoeMarketingScriptsData } from './moe-marketing-scripts.data';
import { IMoeMarketingScriptsProps } from './moe-marketing-scripts.props.autogenerated';

export interface IMoeMarketingScriptsViewProps extends IMoeMarketingScriptsProps<IMoeMarketingScriptsData> {}

/**
 *
 * MoeMarketingScripts component
 * @extends {React.PureComponent<IMoeMarketingScriptsProps<IMoeMarketingScriptsData>>}
 */
class MoeMarketingScripts extends React.PureComponent<IMoeMarketingScriptsProps<IMoeMarketingScriptsData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeMarketingScripts;
